<template>
    <v-container fluid>
      <v-container fluid >
        <!-- Lead Summary -->
        <v-card class="mb-4">
          <v-toolbar
            dark
            color="primary darken-1"
            class="mt-2 mb-3"
            :extended="$vuetify.breakpoint.smAndDown"
          >
            <h2 class="headline font-weight-bold">Lead Summary</h2>
            <v-spacer></v-spacer>
            <v-divider
              class="mx-4"
              inset
              vertical
              v-if="$vuetify.breakpoint.mdAndUp"
            ></v-divider>
            <v-spacer></v-spacer>
            <v-spacer v-if="$vuetify.breakpoint.mdAndUp"></v-spacer>
            
            <template v-slot:extension v-if="$vuetify.breakpoint.smAndDown">
              <v-select
                v-model="selectedCompany"
                :items="companyOptions"
                item-value="name"
                item-text="desc"
                label="Select Company"                
                return-object
                @change="fetchData"
                class="mt-7"
                ></v-select>
            </template>
            <v-select
                v-if="$vuetify.breakpoint.mdAndUp"
                v-model="selectedCompany"
                :items="companyOptions"
                item-value="name"
                item-text="desc"
                label="Select Company"                
                return-object
                @change="fetchData"
                class="mt-7"
                >
            </v-select>
           
            <v-spacer></v-spacer>
            <v-btn icon fab @click="openFilterDialog">
              <v-icon>mdi-filter-menu-outline</v-icon>
            </v-btn>
            <v-btn right icon>
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-toolbar>
           <!-- New section to display selected filters -->
           <v-expand-transition>
            <v-sheet
              v-if="hasSelectedFilters"
              class="pa-3 mb-3"
              color="grey lighten-4"
              rounded
            >
              <v-row align="center" no-gutters>
                <v-col cols="auto" class="mr-3">
                  <v-icon color="primary">mdi-filter</v-icon>
                  <span class="font-weight-medium ml-2">Active Filters:</span>
                </v-col>
                <v-col>
                  <v-chip-group>
                    <v-chip
                      v-for="filter in formattedFilters"
                      :key="filter.label"
                      class="ma-1"
                      small
                      outlined
                      color="primary"
                      close
                      @click:close="removeFilter(filter)"
                      close-icon="mdi-close-circle-outline" 
                      close-color="red" 
                    >
                      <v-icon left small color="primary">{{ getFilterIcon(filter.label) }}</v-icon>
                      <strong>{{ filter.label }}:</strong> {{ filter.value }}
                      <template v-slot:close>
                        <v-icon color="red" @click="removeFilter(filter)">mdi-close</v-icon>
                      </template>
                    </v-chip>
                  </v-chip-group>
                </v-col>
                <v-col cols="auto">
                  <v-btn
                    small
                    text
                    color="primary"
                    @click="clearAllFilters"
                  >
                    Clear All
                  </v-btn>
                </v-col>
              </v-row>
            </v-sheet>
          </v-expand-transition>

          <v-card-text>
            <v-row>
              <v-col cols="6" sm="3">
                <v-stat-card
                  title="Total Leads"
                  :value="leads.length"
                  color="primary"
                  icon="mdi-account-multiple"
                />
              </v-col>
              <v-col cols="6" sm="3">
                <v-stat-card
                  title="New Leads"
                  :value="newLeadsCount"
                  color="success"
                  icon="mdi-account-plus"
                />
              </v-col>
              <v-col cols="6" sm="3">
                <v-stat-card
                  title="Follow-ups Due"
                  :value="followUpsDueCount"
                  color="warning"
                  icon="mdi-clock-alert"
                />
              </v-col>
              <v-col cols="6" sm="3">
                <v-stat-card
                  title="Conversion Rate"
                  :value="conversionRate + '%'"
                  color="info"
                  icon="mdi-chart-line"
                />
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- <v-row>
          <v-col cols="12">
            <v-card class="mb-4">
              <v-toolbar
                dark
                color="primary darken-1"
                class="mt-2 mb-3"
                >  
                <h2 class="headline font-weight-bold">
                  Lead Summary
                </h2>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-btn icon fab large @click="openFilterDialog">
                  <v-icon >mdi-filter-menu-outline</v-icon>
              </v-btn> 
                <v-autocomplete
                    v-model="selectedStatuses"
                    :items="statusOptions"
                    label="Statuses"
                    multiple
                    chips
                    class="mt-5"                    
                ></v-autocomplete>
                <v-btn icon>
                    <v-icon>mdi-dots-vertical</v-icon>  
                </v-btn>   
              </v-toolbar> 
              <v-card-text>
                <v-row>
                  <v-col cols="6" sm="3">
                    <v-stat-card
                      title="Total Leads"
                      :value="leads.length"
                      color="primary"
                      icon="mdi-account-multiple"
                    />
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-stat-card
                      title="New Leads"
                      :value="newLeadsCount"
                      color="success"
                      icon="mdi-account-plus"
                    />
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-stat-card
                      title="Follow-ups Due"
                      :value="followUpsDueCount"
                      color="warning"
                      icon="mdi-clock-alert"
                    />
                  </v-col>
                  <v-col cols="6" sm="3">
                    <v-stat-card
                      title="Conversion Rate"
                      :value="conversionRate + '%'"
                      color="info"
                      icon="mdi-chart-line"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row> -->

        <!-- Filters -->
        <v-dialog v-model="filterDialog" max-width="750px" persistent fullscreen-breakpoint="sm">
        <v-card class="mb-4" v-if="userRole === 'coordinator'">
          <v-toolbar color="primary" dark>
            <v-toolbar-title>Filters</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="closeFilterDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          
          <v-card-text>
            <v-form @submit.prevent="applyFilters">
              <v-row>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="selectedSalesmen"
                    :items="salesmen"
                    label="Salesmen"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                  <v-autocomplete
                    v-model="selectedNavigators"
                    :items="navigators"
                    label="Navigators"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12">                 
                  <v-autocomplete
                    v-model="selectedStatuses"
                    :items="statusOptions"
                    label="Statuses"
                    multiple
                    chips
                    small-chips
                    deletable-chips
                    clearable
                    class="mt-2"
                    dense
                  >
                    <template v-slot:selection="{ attrs, item, select, selected }">
                      <v-chip
                        v-bind="attrs"
                        :input-value="selected"
                        close
                        @click="select"
                        @click:close="removeStatus(item)"
                        outlined
                        small
                        class="ma-1"
                      >
                        {{ item }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="fromDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fromDate"
                        label="From Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="fromDate = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="fromDate"
                      @input="fromDateMenu = false"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-menu
                    v-model="toDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="toDate"
                        label="To Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        @click:clear="toDate = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="toDate"
                      @input="toDateMenu = false"
                      no-title
                      scrollable
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          
          <v-card-actions>
            <v-row justify="space-between">
              <v-col cols="6" sm="3">
                <v-btn block color="primary" @click="applyFilters" :loading="isLoading">
                  Apply 
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3">
                <v-btn block color="primary" @click="applyFilters" :loading="isLoading">
                  Fetch 
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3">
                <v-btn block outlined color="error" @click="clearFilters" :disabled="isLoading">
                  Clear 
                </v-btn>
              </v-col>
              <v-col cols="6" sm="3">
                <v-btn block outlined color="warning" @click="closeFilterDialog" :disabled="isLoading">
                  Cancel
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
        </v-dialog>
  
        <!-- Leads List -->
        <v-toolbar
        dark
        color="primary darken-1"
        class="mt-2 mb-3"
        :extended="$vuetify.breakpoint.smAndDown"
        >  
        <h2 class="headline font-weight-bold">
          Leads
        </h2>
        <v-spacer></v-spacer>
        <v-divider
          class="mx-4"
          inset
          vertical
          v-if="$vuetify.breakpoint.mdAndUp"
        ></v-divider>
        
        <v-spacer></v-spacer>

        <template v-slot:extension v-if="$vuetify.breakpoint.smAndDown">
        
        <v-text-field
            v-model="search"
            hide-details
            append-icon="mdi-magnify"
            single-line
            label="Search"
            :loading="isSearching"       
        ></v-text-field> 
      </template>
        <v-text-field
          v-if="$vuetify.breakpoint.mdAndUp"
            v-model="search"
            hide-details
            append-icon="mdi-magnify"
            single-line
            label="Search"
            :loading="isSearching"       
        ></v-text-field> 

        <v-spacer></v-spacer>
        <v-btn icon fab large @click="addNewLead">
            <v-icon> mdi-account-plus</v-icon>
        </v-btn> 
        <v-btn icon>
            <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </v-toolbar>       
        <v-row>
          <v-col cols="12" sm="6" md="4" v-for="lead in filteredLeads" :key="lead.id">
            <v-card class="mb-4 d-flex flex-column lead-card">
              <v-card-title class="subtitle-1 font-weight-bold">
                {{ lead.customer_name }}
                <v-spacer></v-spacer>
                <v-chip :color="getStatusColor(lead.status)" small>
                  {{ lead.status }}
                </v-chip>
              </v-card-title>
              <v-card-subtitle>{{ lead.contact_name }}</v-card-subtitle>
              <v-card-subtitle>
              {{ lead.contact_name }}
             
            </v-card-subtitle>
              <v-card-text class="flex-grow-1">
                <v-row dense>
                  <v-col cols="12" sm="6">
                    <v-icon small class="mr-1">mdi-email</v-icon>{{ lead.email }}<br>
                    <v-icon small class="mr-1">mdi-phone</v-icon>{{ lead.phone }}<br>
                    <v-icon small class="mr-1">mdi-map-marker</v-icon>{{ lead.country }}
                  </v-col>
                  <v-col cols="12" sm="6">
                    <strong>Next Follow-up:</strong> {{ formatDate(lead.next_follow_up) }}<br>
                    <strong>Created:</strong> {{ formatDate(lead.created_at) }}
                    
                  </v-col>
                  <v-chip class="ml-2" small color="primary" v-if="lead.salesman">
                        Salesman: {{ lead.salesman }}
                    </v-chip>
                    <v-chip class="ml-2" small color="secondary" v-if="lead.navigator">
                        Navigator: {{ lead.navigator }}
                    </v-chip>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-btn icon fab color="primary" @click="openFollowUpDialog(lead)">
                  <v-icon left>mdi-plus-circle</v-icon>
                </v-btn>
                <v-btn  icon fab color="secondary" @click="viewFollowUps(lead)">
                  <v-icon left>mdi-history</v-icon>
                </v-btn>
                <v-btn  icon fab  color="info" @click="editLead(lead)">
                  <v-icon left>mdi-pencil</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
  
      <!-- Follow-up Dialog -->
      <v-dialog v-model="followUpDialog" max-width="500px" fullscreen-breakpoint="xs">
        <v-card>
          <v-card-title>Add Follow-up</v-card-title>
          <v-card-text>
            <v-form ref="followUpForm" v-model="followUpFormValid">
              <v-select
                v-model="newFollowUp.status"
                :items="statusOptions"
                label="Status"
                required
              ></v-select>
              <v-textarea
                v-model="newFollowUp.description"
                label="Description"
                required
              ></v-textarea>
              <v-date-picker
                v-model="newFollowUp.next_follow_up"
                label="Next Follow-up Date"
                required
              ></v-date-picker>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeFollowUpDialog">Cancel</v-btn>
            <v-btn color="blue darken-1" text @click="saveFollowUp">Save</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- View Follow-ups Dialog -->
      <v-dialog v-model="viewFollowUpsDialog" max-width="700px"  fullscreen-breakpoint="xs">
        <v-card>
          <v-card-title>Follow-up History</v-card-title>
          <v-card-text>
            <v-timeline dense>
              <v-timeline-item
                v-for="followUp in selectedLead.follow_ups"
                :key="followUp.id"
                :color="getStatusColor(followUp.status)"
                small
              >
                <template v-slot:opposite>
                  {{ formatDate(followUp.created_at) }}
                </template>
                <v-card class="elevation-2">
                  <v-card-title class="text-h6">{{ followUp.status }}</v-card-title>
                  <v-card-text>
                    {{ followUp.description }}
                    <div class="mt-2">
                      <strong>Next Follow-up:</strong> {{ formatDate(followUp.next_follow_up) }}
                    </div>
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="viewFollowUpsDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit Lead Dialog -->
      <v-dialog v-model="editLeadDialog" max-width="500px" fullscreen-breakpoint="xs">
      <v-card>
          <v-card-title>Edit Lead</v-card-title>
          <v-card-text>
          <v-form ref="editLeadForm" v-model="editLeadFormValid">
              <v-text-field v-model="editedLead.customer_name" label="Customer Name" required></v-text-field>
              <v-text-field v-model="editedLead.contact_name" label="Contact Name" required></v-text-field>
              <v-text-field v-model="editedLead.email" label="Email" required type="email"></v-text-field>
              <v-text-field v-model="editedLead.phone" label="Phone" required></v-text-field>
              <v-text-field v-model="editedLead.country" label="Country" required></v-text-field>
              <v-select v-model="editedLead.status" :items="statusOptions" label="Status" required></v-select>
              <v-date-picker v-model="editedLead.next_follow_up" label="Next Follow-up Date" required></v-date-picker>
              <v-select
                  v-model="editedLead.salesman"
                  :items="salesmen"
                  label="Salesman"
                  required
                  ></v-select>
                  <v-select
                  v-model="editedLead.navigator"
                  :items="navigators"
                  label="Navigator"
                  required
                  ></v-select>
          </v-form>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="saveEditedLead">Save</v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>

      <!-- Add New Lead Dialog -->
      <v-dialog v-model="addLeadDialog" max-width="500px" fullscreen-breakpoint="xs">
      <v-card>
          <v-card-title>Add New Lead</v-card-title>
          <v-card-text>
          <v-form ref="addLeadForm" v-model="addLeadFormValid">
              <v-text-field v-model="newLead.customer_name" label="Customer Name" required></v-text-field>
              <v-text-field v-model="newLead.contact_name" label="Contact Name" required></v-text-field>
              <v-text-field v-model="newLead.email" label="Email" required type="email"></v-text-field>
              <v-text-field v-model="newLead.phone" label="Phone" required></v-text-field>
              <v-text-field v-model="newLead.country" label="Country" required></v-text-field>
              <v-select v-model="newLead.status" :items="statusOptions" label="Status" required></v-select>
              <v-select
                  v-model="newLead.salesman"
                  :items="salesmen"
                  label="Salesman"
                  required
                  ></v-select>
                  <v-select
                  v-model="newLead.navigator"
                  :items="navigators"
                  label="Navigator"
                  required
                  ></v-select>
              <v-date-picker v-model="newLead.next_follow_up" label="Next Follow-up Date" required></v-date-picker>
          </v-form>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeAddDialog">Cancel</v-btn>
          <v-btn color="blue darken-1" text @click="saveNewLead">Save</v-btn>
          </v-card-actions>
      </v-card>
      </v-dialog>
  
      <!-- Floating Action Button for adding new lead -->
      <!-- <v-btn
        fab
        color="primary"
        fixed
        bottom
        right
        @click="addNewLead"
        class="mb-4 mr-4"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn> -->
    </v-container>
  </template>
  
<script>
import moment from 'moment';
import VStatCard from '@/components/VStatCard.vue';
import dynamic_axios from "../services/dynamic_axios";
  export default {
    components: {
        VStatCard
    },
    data() {
      return {
        leads: [
          {
            id: 1,
            customer_name: "Acme Corp",
            contact_name: "John Doe",
            email: "john@acme.com",
            phone: "+1234567890",
            country: "USA",
            status: "New",
            next_follow_up: "2024-07-05",
            created_at: "2024-06-29",
            salesman: "Alice Smith",
            navigator: "Bob Johnson",
            follow_ups: [
              {
                id: 1,
                status: "New",
                description: "Initial contact made",
                next_follow_up: "2024-07-05",
                created_at: "2024-06-29"
              }
            ]
          },
          // Add more dummy leads here
        ],
        selectedCompany:null,
        companyOptions: [
            { name: 'skymat', desc: 'SKYMAT' },
            { name: 'triton', desc: 'TRITON' }
        ],
        isLoading: false,
        filterDialog:false,
        followUpDialog: false,
        viewFollowUpsDialog: false,
        selectedLead: '',
        newFollowUp: {
          status: "",
          description: "",
          next_follow_up: null
        },
        editLeadFormValid: false,
        addLeadFormValid: false,
        followUpFormValid: false,
        statusOptions: ["New", "Contacted", "Qualified", "Proposal", "Negotiation", "Closed Won", "Closed Lost"],
        editLeadDialog: false,
        addLeadDialog: false,
        editedLead: {},
        newLead: {
          customer_name: "",
          contact_name: "",
          email: "",
          phone: "",
          country: "",
          status: "New",
          next_follow_up: moment().add(7, 'days').format('YYYY-MM-DD'),
        },
        selectedSalesmen: [],
        selectedNavigators: [],
        selectedStatuses: [],
         // Simulated user role
        userRole: 'coordinator', // Can be 'coordinator', 'salesman', or 'navigator'
        
        // Simulated lists of salesmen and navigators
        salesmen: ['Alice Smith', 'Charlie Brown', 'David Lee'],
        navigators: ['Bob Johnson', 'Eva White', 'Frank Thomas'],
        isSearching:false,
        search:null,
        fromDateMenu: false,
        toDateMenu: false, 
        custsearch: null,
        fromDate:new Date(new Date().getFullYear(),new Date().getMonth(), 2).toISOString().substr(0, 10),
        toDate:new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substr(0, 10),
       };
    },
  computed: {
    newLeadsCount() {
      return this.leads.filter(lead => lead.status === "New").length;
    },
    followUpsDueCount() {
      const today = moment();
      return this.leads.filter(lead => moment(lead.next_follow_up).isSameOrBefore(today, 'day')).length;
      },
    conversionRate() {
      const closedWon = this.leads.filter(lead => lead.status === "Closed Won").length;
      return ((closedWon / this.leads.length) * 100).toFixed(2);
    },
    filteredLeads() {
      if (this.userRole !== 'coordinator' || 
          (!this.selectedSalesmen.length && !this.selectedNavigators.length && !this.selectedStatuses.length)) {
          return this.leads;
      }
      
      return this.leads.filter(lead => 
          (this.selectedSalesmen.length === 0 || this.selectedSalesmen.includes(lead.salesman)) &&
          (this.selectedNavigators.length === 0 || this.selectedNavigators.includes(lead.navigator)) &&
          (this.selectedStatuses.length === 0 || this.selectedStatuses.includes(lead.status))
      );
    },
    hasSelectedFilters() {
      return this.selectedStatuses.length > 0 || this.selectedSalesmen.length > 0 || 
            this.selectedNavigators.length > 0 || this.fromDate || this.toDate;
    },
    formattedFilters() {
      const filters = [];
      if (this.selectedStatuses.length > 0) {
        filters.push({ label: 'Statuses', value: this.selectedStatuses.join(', ') });
      }
      if (this.selectedSalesmen.length > 0) {
        filters.push({ label: 'Salesmen', value: this.selectedSalesmen.join(', ') });
      }
      if (this.selectedNavigators.length > 0) {
        filters.push({ label: 'Navigators', value: this.selectedNavigators.join(', ') });
      }
      if (this.fromDate) {
        filters.push({ label: 'From Date', value: this.fromDate });
      }
      if (this.toDate) {
        filters.push({ label: 'To Date', value: this.toDate });
      }
      return filters;
    }
  },
  methods: {
    async fetchData() {
        // console.log("hu")
        this.loading = true;
        try {
            const user_id = this.user.USER_LOGINID;
            const company = this.selectedCompany?.name;
            const params = new URLSearchParams({
                user_id
                }).toString();
          const response = await dynamic_axios.get(`/leads/salesleads?${params}`, {
            apiName:company  // Specify which API configuration to use
          });
          this.summaryData = response.data;
        } catch (error) {
          console.error('Error fetching data:', error);
          // You might want to add error handling here, such as displaying a snackbar
        } finally {
          this.loading = false;
        }
      },
      formatDate(date) {
          return moment(date).format('MMM DD, YYYY');
      },
      getStatusColor(status) {
          const colors = {
          "New": "primary",
          "Contacted": "info",
          "Qualified": "success",
          "Proposal": "warning",
          "Negotiation": "orange",
          "Closed Won": "green",
          "Closed Lost": "error"
          };
          return colors[status] || "grey";
      },
      openFilterDialog(){
        this.filterDialog = true;
      },
      closeFilterDialog(){
        this.filterDialog = false;
      } ,
      openFollowUpDialog(lead) {
          this.selectedLead = lead;
          this.followUpDialog = true;
      },
      closeFollowUpDialog() {
          this.followUpDialog = false;
          this.newFollowUp = {
          status: "",
          description: "",
          next_follow_up: null
          };
      },
      saveFollowUp() {
          if (this.$refs.followUpForm.validate()) {
          const followUp = {
              id: Date.now(), // Use a proper ID in production
              ...this.newFollowUp,
              created_at: moment().format('YYYY-MM-DD')
          };
          this.selectedLead.follow_ups.unshift(followUp);
          this.selectedLead.status = followUp.status;
          this.selectedLead.next_follow_up = followUp.next_follow_up;
          this.closeFollowUpDialog();
          this.$toast.success("Follow-up added successfully.");
          }
      },
      viewFollowUps(lead) {
          this.selectedLead = lead;
          this.viewFollowUpsDialog = true;
      },
      editLead(lead) {
          this.editedLead = { ...lead };
          this.editLeadDialog = true;
      },
      applyFilters() {
        // The actual filtering is handled by the computed property 'filteredLeads'
          // But we can use this method to perform additional actions when filters change

          // For example, we might want to reset to the first page of results
          this.currentPage = 1;

      // Or we might want to log the filter change for analytics
      console.log('Filters applied:', {
      salesmen: this.selectedSalesmen,
      navigators: this.selectedNavigators,
      statuses: this.selectedStatuses
      });

      // If you're using vue-router, you might want to update the URL to reflect the current filters
      this.$router.push({ 
      query: { 
          salesmen: this.selectedSalesmen.join(','),
          navigators: this.selectedNavigators.join(','),
          statuses: this.selectedStatuses.join(',')
      }
      });

      // You could also emit an event in case a parent component needs to know about the filter change
      this.$emit('filters-changed', {
      salesmen: this.selectedSalesmen,
      navigators: this.selectedNavigators,
      statuses: this.selectedStatuses
      });
      },
      clearFilters() {
      this.selectedSalesmen = [];
      this.selectedNavigators = [];
      this.selectedStatuses = [];
      },

      saveEditedLead() {
          if (this.$refs.editLeadForm.validate()) {
          const index = this.leads.findIndex(l => l.id === this.editedLead.id);
          if (index !== -1) {
              this.leads.splice(index, 1, this.editedLead);
              this.$toast.success("Lead updated successfully.");
              this.editLeadDialog = false;
          }
          }
      },

      addNewLead() {
          this.addLeadDialog = true;
      },

      saveNewLead() {
          if (this.$refs.addLeadForm.validate()) {
          const newLead = {
              id: Date.now(), // Use a proper ID generation method in production
              ...this.newLead,
              created_at: moment().format('YYYY-MM-DD'),
              follow_ups: []
          };
          this.leads.unshift(newLead);
          this.$toast.success("New lead added successfully.");
          this.addLeadDialog = false;
          this.resetNewLeadForm();
          }
      },

      resetNewLeadForm() {
          this.newLead = {
          customer_name: "",
          contact_name: "",
          email: "",
          phone: "",
          country: "",
          status: "New",
          next_follow_up: moment().add(7, 'days').format('YYYY-MM-DD'),
          salesman: "",
          navigator: "",
          };
      },

      closeEditDialog() {
          this.editLeadDialog = false;
      },

      closeAddDialog() {
          this.addLeadDialog = false;
          this.resetNewLeadForm();
      },
      removeStatus(item) {
        this.selectedStatuses.splice(this.selectedStatuses.indexOf(item), 1)
      },
      getFilterIcon(label) {
        const icons = {
          'Statuses': 'mdi-flag',
          'Salesmen': 'mdi-account-tie',
          'Navigators': 'mdi-compass',
          'From Date': 'mdi-calendar-start',
          'To Date': 'mdi-calendar-end'
        };
        return icons[label] || 'mdi-filter-variant';
      },
      removeFilter(filter) {
        // Implement logic to remove the specific filter
        switch(filter.label) {
          case 'Statuses':
            this.selectedStatuses = [];
            break;
          case 'Salesmen':
            this.selectedSalesmen = [];
            break;
          case 'Navigators':
            this.selectedNavigators = [];
            break;
          case 'From Date':
            this.fromDate = null;
            break;
          case 'To Date':
            this.toDate = null;
            break;
        }
      },
      clearAllFilters() {
        this.selectedStatuses = [];
        this.selectedSalesmen = [];
        this.selectedNavigators = [];
        this.fromDate = null;
        this.toDate = null;
      },
    }
  };
</script>
  
<style scoped>
.lead-card {
  height: 100%; /* Make all cards take full height of their container */
}
.max-width-300 {
  max-width: 300px;
}

.v-card__text {
  overflow: auto; /* Add scrollbar if content overflows */
}
  .v-card {
    transition: all 0.3s;
  }
  .v-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  }
  /* Responsive styles */
@media (max-width: 600px) {
  .v-card-title {
    font-size: 1.1rem !important;
  }
  .v-card-subtitle {
    font-size: 0.9rem !important;
  }
  .v-card-text {
    font-size: 0.85rem !important;
  }
  .v-btn {
    font-size: 0.8rem !important;
  }
}
  </style>